// Ambience manifest — Parcel url: imports for lazy-loaded biome loops

import oceanUrl from 'url:../../assets/sfx/ambience/ocean.webm';
import grassUrl from 'url:../../assets/sfx/ambience/grass.webm';
import grasslandUrl from 'url:../../assets/sfx/ambience/grassland.webm';
import mountainUrl from 'url:../../assets/sfx/ambience/mountain.webm';
import snowUrl from 'url:../../assets/sfx/ambience/snow.webm';
import desertUrl from 'url:../../assets/sfx/ambience/desert.webm';
import deadplainsUrl from 'url:../../assets/sfx/ambience/deadplains.webm';

export const BIOME_IDS = [
  'ocean',
  'grass',
  'grassland',
  'mountain',
  'snow',
  'desert',
  'deadplains',
];

export const AMBIENCE_MANIFEST = {
  ocean: oceanUrl,
  grass: grassUrl,
  grassland: grasslandUrl,
  mountain: mountainUrl,
  snow: snowUrl,
  desert: desertUrl,
  deadplains: deadplainsUrl,
};
